var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/tag-user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tag-user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 15.7141H14.3667C13.7 15.7141 13.0667 15.9724 12.6 16.4391L11.175 17.8474C10.525 18.4891 9.46668 18.4891 8.81668 17.8474L7.39166 16.4391C6.925 15.9724 6.28333 15.7141 5.625 15.7141H5C3.61667 15.7141 2.5 14.6057 2.5 13.2391V4.13906C2.5 2.7724 3.61667 1.66406 5 1.66406H15C16.3833 1.66406 17.5 2.7724 17.5 4.13906V13.2307C17.5 14.5974 16.3833 15.7141 15 15.7141Z",
    stroke: "#6941C6",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.0583 7.46094C10.025 7.46094 9.97498 7.46094 9.93331 7.46094C9.05831 7.4276 8.36664 6.71927 8.36664 5.83594C8.36664 4.93594 9.09165 4.21094 9.99165 4.21094C10.8916 4.21094 11.6167 4.94427 11.6167 5.83594C11.625 6.71927 10.9333 7.43594 10.0583 7.46094Z",
    stroke: "#6941C6",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.70833 9.96875C6.59999 10.7104 6.59999 11.9187 7.70833 12.6604C8.96666 13.5021 11.0333 13.5021 12.2917 12.6604C13.4 11.9187 13.4 10.7104 12.2917 9.96875C11.0333 9.13542 8.97499 9.13542 7.70833 9.96875Z",
    stroke: "#6941C6",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagUser);
export default __webpack_public_path__ + "static/media/tagUser.ed99efad43b908160be6cdde8e61c14a.svg";
export { ForwardRef as ReactComponent };